import dayjs from "dayjs";
import { HeatOverrideCancellationFilter } from "src/store/api/generatedApi";

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_RANGE_PREFIX = "overrides";
export const CANCELLATION_PARAM = "cancellation";
const LEGACY_DATE_PARAM = "date";
const START_DATE_PARAM = `${DATE_RANGE_PREFIX}_startDate`;
const END_DATE_PARAM = `${DATE_RANGE_PREFIX}_endDate`;

const validDate = (date: string | null, fallback: string) => {
  const parsed = date ? dayjs(date) : null;
  return parsed?.isValid() && parsed.format(DATE_FORMAT) === date
    ? date
    : fallback;
};

export const resolveOverrideHistoryFilters = ({
  searchParams,
  today,
}: {
  searchParams: URLSearchParams;
  today: string;
}) => {
  const defaultDate = validDate(searchParams.get(LEGACY_DATE_PARAM), today);
  const startDate = validDate(searchParams.get(START_DATE_PARAM), defaultDate);
  const requestedEndDate = validDate(
    searchParams.get(END_DATE_PARAM),
    startDate
  );
  const endDate = requestedEndDate < startDate ? startDate : requestedEndDate;
  const cancellation: HeatOverrideCancellationFilter =
    searchParams.get(CANCELLATION_PARAM) === "include" ? "include" : "exclude";
  const normalised =
    searchParams.get(START_DATE_PARAM) === startDate &&
    searchParams.get(END_DATE_PARAM) === endDate;
  return { startDate, endDate, cancellation, normalised };
};

export const normaliseOverrideHistorySearchParams = ({
  searchParams,
  startDate,
  endDate,
}: {
  searchParams: URLSearchParams;
  startDate: string;
  endDate: string;
}) => {
  const next = new URLSearchParams(searchParams);
  next.set(START_DATE_PARAM, startDate);
  next.set(END_DATE_PARAM, endDate);
  next.delete(LEGACY_DATE_PARAM);
  return next;
};
